import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const primaryColor = '#FEB914';
const primaryColorHover = '#f4b113';

export const ThemePreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: '#FEB914',
          contrastColor: '#ffffff',
          hoverColor: '{primary.800}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '#FEB914',
          focusBackground: '{primary.700}',
          color: '#334155',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '{primary.50}',
          contrastColor: '{primary.950}',
          hoverColor: '{primary.200}',
          activeColor: '{primary.300}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.300}',
          color: '{primary.950}',
          focusColor: '{primary.950}',
        },
      },
    },
  },
  components: {
    button: {
      label: {
        font: {
          weight: '600 !important',
        },
      },
      primary: {
        background: primaryColor + '!important',
        color: '#000000 !important',
        border: {
          color: primaryColor + '!important',
        },
        hover: {
          background: primaryColorHover + '!important',
          color: '#000000 !important',
          border: {
            color: primaryColor + '!important',
          },
        },
        active: {
          background: primaryColorHover + '!important',
          border: {
            color: primaryColor + '!important',
          },
        },
      },
    },
    datepicker: {
      date: {
        range: {
          selected: {
            background: '#F5E7C7',
            color: '#334155FF',
          },
        },
        selected: {
          background: primaryColor,
        },
      },
    },
    datatable: {
      header: {
        cell: {
          padding: '10px 10px !important',
        },
      },
      body: {
        cell: {
          padding: '7px 10px !important',
        },
      },
    },
  },
});
